import { useTranslation } from 'react-i18next';
import { Spinner } from './Spinner';

/** Centred spinner for a whole panel or page region. */
export function LoadingState({ label, className }: { label?: string; className?: string }) {
  const { t } = useTranslation();

  return (
    <div className={className ?? 'flex min-h-48 w-full items-center justify-center'}>
      <Spinner label={label ?? t('common.loading')} />
    </div>
  );
}
